// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3-fi6","title":"Header_title__2kHk2","side":"Header_side__3Y1rW"};